export class FbBetModel {
  public betType: number;
  public betAmount: number;
  public betAmountQuota: number;
  public betItemOption: number;
  public winningMargin: string;
  public winningMarginChanged: boolean;
  public odds: string;
  public dividend: number;
  public tipsId: number;
  public createDate: string;
  public note: string;
  public image: string;
  public isRefund: boolean;

  constructor(betType: number, betAmount: number,  betAmountQuota: number, betItemOption: number,
              winningMargin: string, winningMarginChanged: boolean,
              odds: string, dividend: number, tipsId: number, createDate: string, note: string, image: string,
              isRefund: boolean) {
    this.betType = betType;
    this.betAmount = betAmount;
    this.betAmountQuota = betAmountQuota;
    this.betItemOption = betItemOption;
    this.winningMargin = winningMargin;
    this.winningMarginChanged = winningMarginChanged;
    this.odds = odds;
    this.dividend = dividend;
    this.tipsId = tipsId;
    this.createDate = createDate;
    this.note = note;
    this.image = image;
    this.isRefund = isRefund;
  }

  public hasDetails():boolean {
    return (this.note != null && this.note != "") || this.image == "1";
  }
}



// WEBPACK FOOTER //
// ./src/model/FbBetModel.ts